import { getFunctionBaseUrl } from './RestUrls';
import * as rest from './RestUtil';

export interface IReceptionReportMailStatus {
  status: string;
  info: string;
  time: string;
}

export interface IReceptionReport {
  reportId: string;
  date: string;
  autogenReport: boolean;
  success: boolean;
  empty: boolean;
  periodStart: string;
  periodEnd: string;
  info: string;
  mailStatus: IReceptionReportMailStatus;
}

/**
 * @param operatorId 
 * @param startDate start month YYYY-MM
 * @param endDate end month YYYY-MM
 */
export const getReceptionReports = async (operatorId: string, startDate: string, endDate: string) => {
  const url = `${getFunctionBaseUrl()}/api/receptionReports/${operatorId}/${startDate}/${endDate}`;
  const response = await rest.get(url);
  return response as IReceptionReport[];
}

export const getReceptionReportExcel = async (operatorId: string, reportId: string) => {
  const url = `${getFunctionBaseUrl()}/api/GenerateReceptionExcel/${operatorId}/${reportId}`;
  const response = await rest.download(url);
  return response;
}

export const sendReceptionReportEmail = async (operatorId: string, reportId: string, reportLanguage: string = "fi-FI") => {
  const url = `${getFunctionBaseUrl()}/api/sendReceptionReportEmail/${operatorId}/${reportId}/${reportLanguage}`;
  const response = await rest.get(url);
  return response;
}
